import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import NewChatMobileContainer from "@/components/chat/chatContainer/NewChatMobileContainer/NewChatMobileContainer.vue";
import { ChatTypes } from "@/store/chats/types";
import { chatTypeInjectionKey } from "@/utils/chat/chatTypeInjectionKey";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewChatMobileOneToOneChat',
  setup(__props) {

provide(chatTypeInjectionKey, {
  type: ChatTypes.ONE_TO_ONE_CHAT,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NewChatMobileContainer))
}
}

})